
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from "swiper";
import { EffectCards } from "swiper";
import { EffectCreative } from "swiper";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Image } from 'antd';

//<img className="card-image" src="/boundless.png" alt=""/>
function Superdrip() {


    return (
        <div>
        <div className="superdrip-header text-center">
        <h1>The superDRIP collection</h1>
        </div>
        <div className="card-custom-wrapper">
            <div className="card-custom">
                <div className="card-top">
                    <Image className="card-image" src="/boundless.png" 
                    
                    placeholder={
                        <Image
                        preview={false}
                        src="/loading.jpg"
                        />
                    }
                    />
                    <p>Boundless</p></div>
                <div className="card-bottom">
                    <div className="card-data">
                        <span>Source: Auction</span>
                        <span>Final bid: 3k xDRIP</span>
                    </div>
                    <div className="card-links">
                    <a href="https://explorer.solana.com/address/4mLxstCk84WideKopyTwK3KX21grXUEFmkY9BA5rAJzn" title="View on Explorer"><img src="/solscan.png" className="solscan-link" alt=""/></a>
                    </div>
                </div>
                
            </div><div className="card-custom">
                <div className="card-top">
                    <Image className="card-image" src="/waste.png"  placeholder={
                        <Image
                        preview={false}
                        src="/loading.jpg"
                        />
                    }/>
                    <p>Waste</p></div>
                <div className="card-bottom">
                    <div className="card-data">
                        <span>Source: Raffle</span>
                        <span>Totla tickets: 3.1k xDRIP</span>
                    </div>
                    <div className="card-links">
                    <a href="https://solscan.io/token/Fpo657HtyY9MAYNm7DeXRAUBgpro3fGs64bAHU3gxZYs" title="View on Explorer"><img src="/solscan.png" className="solscan-link" alt=""/></a>
                    </div>
                </div>
                
            </div>
            <div className="card-custom">
                <div className="card-top">
                    <Image className="card-image" src="/eternal.png"  placeholder={
                        <Image
                        preview={false}
                        src="/loading.jpg"
                        />
                    }/>
                    <p>Eternal</p></div>
                <div className="card-bottom">
                    <div className="card-data">
                        <span>Source: Auction</span>
                        <span>Final bid: 2k xDRIP</span>
                    </div>
                    <div className="card-links">
                    <a href="https://explorer.solana.com/address/Gdc5F4dZxQy9KgHLWBVBoPkLniVhJBmcE3yJ9aaTqjwF" title="View on Explorer"><img src="/solscan.png" className="solscan-link" alt=""/></a>
                    </div>
                </div>
                
            </div>
            <div className="card-custom">
                <div className="card-top">
                    <Image className="card-image" src="/Ivy.png"  placeholder={
                        <Image
                        preview={false}
                        src="/loading.jpg"
                        />
                    }/>
                    <p>Ivy</p></div>
                <div className="card-bottom">
                    <div className="card-data">
                        <span>Source: Raffle</span>
                        <span>Total tickets: 6k xDRIP</span>
                    </div>
                    <div className="card-links">
                    <a href="https://explorer.solana.com/address/97XiR6reCJhteUUp4AD4P4SHuQz58S4LKkH6cZAZnQuy" title="View on Explorer"><img src="/solscan.png" className="solscan-link" alt=""/></a>
                    </div>
                </div>
                
            </div>
            <div className="card-custom">
                <div className="card-top">
                    <Image className="card-image" src="/desolate.png"  placeholder={
                        <Image
                        preview={false}
                        src="/loading.jpg"
                        />
                    }/>
                    <p>Desolate</p></div>
                <div className="card-bottom">
                    <div className="card-data">
                        <span>Source: Auction</span>
                        <span>Final bid: 3.3k xDRIP</span>
                    </div>
                    <div className="card-links">
                    <a href="https://explorer.solana.com/address/GzUKFgfJ289nMcxgnCmN4yMFTPatHqnWkvzvXX2fP4Ph" title="View on Explorer"><img src="/solscan.png" className="solscan-link" alt=""/></a>
                    </div>
                </div>
                
            </div>
            <div className="card-custom">
                <div className="card-top">
                    <Image className="card-image" src="/Unstable.png"  placeholder={
                        <Image
                        preview={false}
                        src="/loading.jpg"
                        />
                    }/>
                    <p>Unstable</p></div>
                <div className="card-bottom">
                    <div className="card-data">
                        <span>Source: Auction</span>
                        <span>Final bid: 4.3k xDRIP</span>
                    </div>
                    <div className="card-links">
                    <a href="https://explorer.solana.com/address/5J7FhzhabnnR98uLhEkGYKNAj3T3vKHVNjoerp74iFAZ" title="View on Explorer"><img src="/solscan.png" className="solscan-link" alt=""/></a>
                    </div>
                </div>
                
            </div>
        </div>
        <p className="text-center" style={{fontSize: "20px", marginTop: "50px", marginLeft: "5px", marginRight: "5px"}}>More to come with future raffles and auctions!</p>
        </div>
    )
}

export default Superdrip;
